import { View } from "react-native-web";
import { CImage } from "../../../components/atoms";
import { Constants, Images } from "../../../config";

export const prefabCompanyFilterCriteria = (isMobileVersion, styles) => {
  return [
    {
      title: "Location",
      isHide: isMobileVersion,
      isLocation: true,
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_PREFAB_CATEGORY,
      icon: Images.iconTagFeature,
      width: 20,
      height: 20,
      title: "Category",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Big Home",
          tagId: 2901,
        },
        {
          id: 2,
          label: "Tiny Home",
          tagId: 2902,
        },
        {
          id: 3,
          label: "Guesthouse",
          tagId: 2903,
        },
        {
          id: 4,
          label: "Office / Studio",
          tagId: 2904,
        },
        {
          id: 5,
          label: "Mobile on Wheels",
          tagId: 2905,
        },
        {
          id: 6,
          label: "Cabin / Bunkie",
          tagId: 2906,
        },
        {
          id: 7,
          label: "A-Frame",
          tagId: 2907,
        },
        {
          id: 8,
          label: "Container",
          tagId: 2908,
        },
        {
          id: 9,
          label: "Tent",
          tagId: 2909,
        },
        {
          id: 10,
          label: "Yurt",
          tagId: 2910,
        },
        {
          id: 11,
          label: "Dome",
          tagId: 2911,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_SIZE_SQFT,
      icon: Images.iconTagSize,
      width: 20,
      height: 20,
      title: "Size",
      isHide: false,
      isRangeValue: true,
      detailList: [
        {
          id: 1,
          label: "XS - 0-200 sqft",
          value: { minValue: 0, maxValue: 200 },
        },
        {
          id: 2,
          label: "S - 200-500 sqft",
          value: { minValue: 200, maxValue: 500 },
        },
        {
          id: 3,
          label: "M - 500-1k sqft",
          value: { minValue: 500, maxValue: 1000 },
        },
        {
          id: 4,
          label: "L - 1-2k sqft",
          value: { minValue: 1000, maxValue: 2000 },
        },
        {
          id: 5,
          label: "XL 2-5k sqft",
          value: { minValue: 2000, maxValue: 5000 },
        },
        {
          id: 6,
          label: "XXL - +5k sqft",
          value: { minValue: 5000 },
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_PRICE,
      icon: Images.iconTagPrice,
      width: 20,
      height: 20,
      title: "Price",
      isHide: false,
      isRangeValue: true,
      detailList: [
        {
          id: 1,
          label: "$0 - $10k",
          value: { minValue: 0, maxValue: 10000 },
        },
        {
          id: 2,
          label: "$10k - $20k",
          value: { minValue: 10000, maxValue: 20000 },
        },
        {
          id: 3,
          label: "$20k - $50k",
          value: { minValue: 20000, maxValue: 50000 },
        },
        {
          id: 4,
          label: "$50k - $100k",
          value: { minValue: 50000, maxValue: 100000 },
        },
        {
          id: 5,
          label: "$100k - $200k",
          value: { minValue: 100000, maxValue: 200000 },
        },
        {
          id: 6,
          label: "$200k - $500k",
          value: { minValue: 200000, maxValue: 500000 },
        },
        {
          id: 7,
          label: "$500k - $1m",
          value: { minValue: 500000, maxValue: 1000000 },
        },
        {
          id: 8,
          label: "+$1m",
          value: { minValue: 1000000 },
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_PREFAB_ASSEMBLING,
      icon: Images.iconTagGeneral,
      width: 20,
      height: 20,
      title: "Assembling",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Pre-Assembled - Mobile Home",
          tagId: 3901,
        },
        {
          id: 2,
          label: "Pre-Assembled",
          tagId: 3902,
        },
        {
          id: 3,
          label: "Assembled On-Site",
          tagId: 3903,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_HOME_LISTED,
      icon: Images.iconTagGeneral,
      width: 20,
      height: 20,
      title: "Homes Listed",
      isHide: false,
      isCompanyHomeSize: true,
      detailList: [
        {
          id: 1,
          label: "0-5",
          value: { minValue: 0, maxValue: 5 },
        },
        {
          id: 2,
          label: "6-10",
          value: { minValue: 6, maxValue: 10 },
        },
        {
          id: 3,
          label: "+10",
          value: { minValue: 11 },
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_RATING,
      icon: Images.iconTagRating,
      width: 21.5,
      height: isMobileVersion ? 21 : 20,
      title: "Rating",
      isHide: true,
      isRating: true,
      detailList: [
        {
          id: 1,
          label: "1",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating1}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 2,
          label: "2",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating2}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 3,
          label: "3",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating3}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 4,
          label: "4",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating4}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 5,
          label: "5",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating5}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
      ],
      selectedList: [],
    },
  ];
};
